import _ from "lodash";
import Radium from "radium";
import React from "react";

import { menuStyles } from "@common/styles";
import MenuItem from "./menuItem";

export interface IMenuProps {
  authorization: any[];
}

export interface IMenuActions {
  handleMyDevices: () => void;
  handleMyApiKeys: () => void;
  handleAdminUsers: () => void;
  handleChangePassword: () => void;
  goHome: () => void;
  logout: () => void;
}

class Menu extends React.Component<IMenuProps & IMenuActions> {
  public render() {
    const {
      logout,
      authorization,
      handleMyDevices,
      handleMyApiKeys,
      handleAdminUsers,
      handleChangePassword,
      goHome
    } = this.props;

    return (
      <div style={menuStyles.menu} className="menu">
        <MenuItem title="Hjem" handleClick={goHome} />
        <MenuItem title="Håndter dine enheter" handleClick={handleMyDevices} />

        {_.some(authorization, { claim: "api" } as any) ||
        _.some(authorization, { claim: "admin" } as any) ? (
          <MenuItem title="Håndter API-nøkler" handleClick={handleMyApiKeys} />
        ) : null}
        {_.some(authorization, { claim: "admin" } as any) ? (
          <MenuItem
            title="Administrer brukere"
            handleClick={handleAdminUsers}
          />
        ) : null}

        <MenuItem title="Endre passord" handleClick={handleChangePassword} />
        <MenuItem title="Logg ut" handleClick={logout} />
      </div>
    );
  }
}

export default Radium(Menu);
